import { render } from "./VendaModal.vue?vue&type=template&id=fee1ce64&scoped=true&ts=true"
import script from "./VendaModal.vue?vue&type=script&lang=ts"
export * from "./VendaModal.vue?vue&type=script&lang=ts"

import "./VendaModal.vue?vue&type=style&index=0&id=fee1ce64&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee1ce64"]])

export default __exports__